export enum IDownloadReports {
  USER = 1,
}

export interface DownloadReportsProps {
  startPeriod: string;
  lastPeriod: string;
}

export interface DownloadRaReportsProps {
  startDate: string;
  endDate: string;
  type: number;
}

export enum TypeReport {
  RA_SIMPLE = 0,
  RA_COMPLETE = 1,
  AUTOMATIC_MAP_PRODUCT = 2,
  ORDERS = 3,
  DEPARA_WITH_MAPPING = 4,
  DEPARA_WITHOUT_MAPPING = 5,
  SENT_ITEMS_VIVEO = 6,
  SENT_ITEMS_ORIGEM = 7,
}

export enum DeParaSearchType {
  PRODUCT_CODE = 0,
  DESCRIPTION_BRAND = 1,
}

export interface DeParaReportProps {
  startDate: string;
  endDate: string;
  type: TypeReport.DEPARA_WITH_MAPPING | TypeReport.DEPARA_WITHOUT_MAPPING;
  searchType?: DeParaSearchType | null;
  terms?: string[];
}

export interface SentItemsReportProps {
  startDate: string;
  endDate: string;
  type: TypeReport.SENT_ITEMS_VIVEO | TypeReport.SENT_ITEMS_ORIGEM;
  searchType?: DeParaSearchType | null;
  terms?: string[];
}
